module.exports = __webpack_public_path__ + "img/embauche.170fa14b.png";